import React, { createContext, useContext, useEffect, useState } from 'react';

interface DarkModeContextProps {
    isDarkMode: boolean;
    toggleDarkMode: () => void;
}

interface DarkModeProviderProps {
    children: React.ReactNode;
}

const DarkModeContext = createContext<DarkModeContextProps | undefined>(undefined);

export const DarkModeProvider: React.FC<DarkModeProviderProps> = ({ children }) => {

    //const [isDarkMode, setIsDarkMode] = useState(() => {
    //    const savedTheme = localStorage.getItem('theme');
    //    return savedTheme === 'dark' ? true : false;
    //});

    const [isDarkMode, setIsDarkMode] = useState(true);

    //useEffect(() => {
    //    if (isDarkMode) {
    //        document.body.setAttribute('data-bs-theme', 'dark');
    //        localStorage.setItem('theme', 'dark');
    //    } else {
    //        document.body.removeAttribute('data-bs-theme');
    //        localStorage.setItem('theme', 'dark'); // Set to light later
    //    }
    //}, [isDarkMode]);

    useEffect(() => {
        document.body.setAttribute('data-bs-theme', 'dark');
        localStorage.setItem('theme', 'dark');
    }, [isDarkMode]);

    const toggleDarkMode = () => {
        setIsDarkMode((prevMode) => !prevMode);
        const theme = !isDarkMode ? 'dark' : 'light';
        document.documentElement.setAttribute('data-bs-theme', theme);
    };

    return (
        <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
};

export const useDarkMode = () => {
    const context = useContext(DarkModeContext);
    if (context === undefined) {
        throw new Error('useDarkMode must be used within a DarkModeProvider');
    }
    return context;
};
